import { render, staticRenderFns } from "./GroupSignUp.vue?vue&type=template&id=5f7d5164&"
import script from "./GroupSignUp.vue?vue&type=script&lang=js&"
export * from "./GroupSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports